import React, { Component, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import withStyles from '@mui/styles/withStyles';
import { GridNumberField } from '../Form/shared';
import { FormBlock } from '../Form';
import styles from './styles';
import { positiveInteger, positiveNumber } from '../Form/validators';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PanelSummary from '../PanelSummary';

const Details = ({ activePanel, name, label, classes, values, onChange }) => {
  const { t } = useTranslation();
  const summaryItems = useMemo(() => {
    const details = values.outbound.actualPaxLoad?.details;
    return [
      {
        label: t('Male'),
        value: details?.[name]?.male,
      },
      {
        label: t('Female'),
        value: details?.[name]?.female,
      },
      {
        label: t('Child'),
        value: details?.[name]?.child,
      },
      {
        label: t('Infant'),
        value: details?.[name]?.infant,
      },
    ];
  }, [values.outbound.actualPaxLoad, t, name]);

  const baggageSummaryItems = useMemo(() => {
    const details = values.outbound.actualPaxLoad?.details;
    return [
      {
        label: t('Baggage PC'),
        value: details?.[name]?.baggage?.pkgs,
      },
      {
        label: t('Baggage WT'),
        value: details?.[name]?.baggage?.weight,
      },
    ];
  }, [values.outbound.actualPaxLoad, t, name]);
  return (
    <Accordion
      expanded={activePanel === name}
      onChange={onChange.bind(null, name)}
    >
      <AccordionSummary
        className={classes.innerExpansionSummary}
        expandIcon={<ExpandMoreIcon />}
      >
        <PanelSummary title={t(label)} items={summaryItems} />
        <PanelSummary items={baggageSummaryItems} />
      </AccordionSummary>
      <AccordionDetails className={classes.expansionDetails}>
        <FormBlock>
          <GridNumberField
            xs={3}
            name={`outbound.actualPaxLoad.details.${name}.male`}
            label={t('Male')}
            allowedInputValue={positiveInteger}
          />
          <GridNumberField
            xs={3}
            name={`outbound.actualPaxLoad.details.${name}.female`}
            label={t('Female')}
            allowedInputValue={positiveInteger}
          />
          <GridNumberField
            xs={3}
            name={`outbound.actualPaxLoad.details.${name}.child`}
            label={t('Child')}
            allowedInputValue={positiveInteger}
          />
          <GridNumberField
            xs={3}
            name={`outbound.actualPaxLoad.details.${name}.infant`}
            label={t('Infant')}
            allowedInputValue={positiveInteger}
          />
        </FormBlock>
        {t('Baggage')}
        <FormBlock>
          <GridNumberField
            xs={3}
            name={`outbound.actualPaxLoad.details.${name}.baggage.pkgs`}
            label={t('PC')}
            allowedInputValue={positiveInteger}
          />
          <GridNumberField
            xs={3}
            name={`outbound.actualPaxLoad.details.${name}.baggage.weight`}
            label={t('WT')}
            allowedInputValue={positiveNumber}
          />
          <GridNumberField
            xs={3}
            name={`outbound.actualPaxLoad.details.${name}.baggage.handCarry`}
            label={t('Hand Carry')}
            allowedInputValue={positiveInteger}
          />
        </FormBlock>
      </AccordionDetails>
    </Accordion>
  );
};

class ActualPaxLoad extends Component {
  state = {
    activePanel: '',
  };

  handlePanelChange = panel => {
    const { activePanel } = this.state;
    panel = activePanel === panel ? '' : panel;
    this.setState({ activePanel: panel });
  };

  render() {
    const { classes, values } = this.props;
    const { activePanel } = this.state;
    return (
      <div>
        <Details
          name="first"
          label="First"
          activePanel={activePanel}
          onChange={this.handlePanelChange}
          classes={classes}
          values={values}
        />
        <Details
          name="business"
          label="Business"
          activePanel={activePanel}
          onChange={this.handlePanelChange}
          classes={classes}
          values={values}
        />
        <Details
          name="economy"
          label="Economy"
          activePanel={activePanel}
          onChange={this.handlePanelChange}
          classes={classes}
          values={values}
        />
      </div>
    );
  }
}

export default withStyles(styles)(ActualPaxLoad);
